import React from 'react';
import { useTranslation } from 'react-i18next';

const SkipToContent = () => {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[200] focus:px-4 focus:py-2 focus:bg-black focus:text-white focus:rounded focus:outline focus:outline-2 focus:outline-accent-orange"
    >
      {t('common.skip_to_content')}
    </a>
  );
};

export default SkipToContent;
